import { useState } from "react";

export function useManageReturnToAllQ() {
  const [showAllQ, setShowAllQ] = useState(true);
  const [showQ, setShowQ] = useState(false);
  const [showReports, setShowReports] = useState(false);

  /**
   * Function to handle the return to questionnaire selection
   */
  const manageReturnToAllQ = () => {
    setShowAllQ(true);
    setShowQ(false);
    setShowReports(false);
  };

  return {
    showAllQ,
    setShowAllQ,
    showQ,
    setShowQ,
    showReports,
    setShowReports,
    manageReturnToAllQ,
  };
}
